import React from 'react';
import cnames from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import List, { ListItem } from '../../../../List';
import * as constants from '../../../../constants';
import Box from '../../../../Box';
import Modal, { ModalBody } from '../../../../Modal';
import Text from '../../../../Text';
import Logo from '../../../../Logo';
import _styles from './themes/default.scss';

const messages = defineMessages({
  userAgreement: { defaultMessage: 'User Agreement' },
  privacyPolicy: { defaultMessage: 'Privacy Policy' },
  cookieSettings: { defaultMessage: 'Cookie Settings' },
  cookiePolicy: { defaultMessage: 'Cookie Policy' },
});

const displayImpressum = (country, locale) => { return ['DE', 'CH', 'AT'].includes(country) || locale === 'de'; };

// eslint-disable-next-line no-undef
const openCookiebotSettings = () => Object.hasOwnProperty.call(window, 'Cookiebot') && Cookiebot.renew();

const FooterLegal = ({ baseUrl, country, locale, styles, parentStyles }) => (
  <div className={cnames(styles.footerLegal, parentStyles.footerLegal)}>
    <div className={styles.footerContainer}>
      <List className={styles.listHorizontal}>
        <ListItem>
          <a href={baseUrl} className={styles.redbubbleLogo} rel="nofollow">
            <Logo colored={false} contrast />
          </a>
        </ListItem>
      </List>
      <Box marginTop="m" />
      <List className={styles.listHorizontal}>
        <ListItem>
          <Text type="body2">
            <a
              className={styles.link}
              href={`${baseUrl}/agreement`}
              rel="nofollow"
            >
              <FormattedMessage {...messages.userAgreement} />
            </a>
          </Text>
        </ListItem>
        <ListItem>
          <Text type="body2">
            <a
              className={styles.link}
              href={`${baseUrl}/privacy`}
              rel="nofollow"
            >
              <FormattedMessage {...messages.privacyPolicy} />
            </a>
          </Text>
        </ListItem>
        <ListItem>
          <Text type="body2">
            <button type="button" className={styles.link} onClick={openCookiebotSettings}>
              {country === 'US' ? 'Do Not Sell or Share My Personal Information' : (
                <FormattedMessage {...messages.cookieSettings} />
              )}
            </button>
          </Text>
        </ListItem>
        <ListItem>
          <Text type="body2">
            <a className={styles.link} href={`${baseUrl}/cookie-policy`}>
              <FormattedMessage {...messages.cookiePolicy} />
            </a>
          </Text>
        </ListItem>
        {displayImpressum(country, locale) && (
          <ListItem>
            <Modal
              trigger={({ onClick }) => (
                <button type="button" className={styles.link} onClick={onClick}>
                  <Text type="body2">
                    Impressum
                  </Text>
                </button>
              )}
              accessibleTitle="Impressum"
              getApplicationNode={() => document.getElementById('root')}
              size={constants.MEDIUM}
            >
              <ModalBody>
                <Box paddingLeft="m" paddingRight="m" paddingBottom="xl">
                  <Box marginBottom="xl" element="h2">
                    <Text display="block" type="display2">
                      Impressum
                    </Text>
                  </Box>

                  <Box marginBottom="xs">
                    <Text element="p">
                      <strong>www.redbubble.com</strong> (einschließlich
                      {' '}
                      <strong>
                        www.redbubble.com/de
                      </strong>
                      ) ist ein Angebot der:
                    </Text>
                  </Box>

                  <Box padding="l">
                    <address className={styles.address}>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>Redbubble Inc.</strong>
                          , Aktiengesellschaft mit Sitz in Delaware, USA.
                        </Text>
                      </Box>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>Adresse:</strong>
                          {' '}
                          170 Grant Avenue, Suite 600, San Francisco, CA 94108, USA
                        </Text>
                      </Box>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>Telefon:</strong> <a href="tel:+493056837185">+49 (0) 30 5683 7185</a>
                        </Text>
                      </Box>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>E-Mail:</strong>
                          {' '}
                          <a href="mailto:legal@redbubble.com">legal@redbubble.com</a>
                        </Text>
                      </Box>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>Steuernummer:</strong> 205-4102-65
                        </Text>
                      </Box>
                      <Box paddingBottom="xxs">
                        <Text display="block" type="body">
                          <strong>Gesetzlicher Vertreter von Redbubble Inc.:</strong>
                          {' '}
                          Frau Corina Davis
                        </Text>
                      </Box>
                    </address>
                  </Box>

                  <Box padding="xxs">
                    <Text display="block" type="body">
                      <strong>Rechtlicher Hinweis:</strong> Die Europäische
                      Kommission stellt eine Plattform zur{' '}
                      Online-Streitbeilegung zur Verfügung, die du unter{' '}
                      <a
                        href="https://ec.europa.eu/consumers/odr/"
                        title="Online-Streitbeilegung"
                      >
                        https://ec.europa.eu/consumers/odr/
                      </a>
                      {' '}
                      abrufen kannst.
                    </Text>
                  </Box>
                </Box>


              </ModalBody>
            </Modal>
          </ListItem>
        )}
      </List>
    </div>
  </div>
);

FooterLegal.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  country: PropTypes.string,
  locale: PropTypes.string,
  styles: PropTypes.shape({}),
  parentStyles: PropTypes.shape({}).isRequired,
};

FooterLegal.defaultProps = {
  country: null,
  locale: '',
  styles: _styles,
};

FooterLegal.displayName = 'FooterLegal';

export default FooterLegal;
